import { useThemeStore } from './store';
import type { ThemeColors } from './store';
import { useRtl } from '../i18n/useRtl';

/**
 * Bundle for screens: live palette, light/dark appearance, and RTL helpers.
 * Reduces repeated `useThemeColors` + `useThemeStore(appearance)` + `useRtl()` boilerplate.
 */
export function useScreenTheme(): {
  colors: ThemeColors;
  appearance: 'light' | 'dark';
  rtl: ReturnType<typeof useRtl>;
} {
  const colors = useThemeStore(s => s.colors);
  const appearance = useThemeStore(s => s.appearance);
  const rtl = useRtl();
  return { colors, appearance, rtl };
}
